export const transformObjectToQueryString = (filters: any = {}) =>
  Object.keys(filters)
    .filter((x) => filters[x])
    .map((k) => `${k}=${filters[k]}`)
    .join("&");
